export const AddCategory_REQUEST = "AddCategory_REQUEST";
export const AddCategory_SUCCESS = "AddCategory_SUCCESS";
export const AddCategory_FAIL = "AddCategory_FAIL";

export const GetAllCategory_REQUEST = "GetAllCategory_REQUEST";
export const GetAllCategory_SUCCESS = "GetAllCategory_SUCCESS";
export const GetAllCategory_FAIL = "GetAllCategory_FAIL";


